import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../global/icon';
import LegacyBadge from '../../global/badge';
import { cdn } from '~/modules/services/image-service';

function ProjectCard({ project, canEdit = false, onEditClick }) {
	const [posterLoaded, setPosterLoaded] = useState(false);
	const posterUrl = cdn(project.poster);
	const safePosterUrl = posterUrl?.replace(/^http:\/\/\/\//, 'https://') || (project.poster ? `https:${project.poster}` : null);

	const handleEditClick = () => {
		onEditClick && onEditClick();
	};

	const handleImgLoad = () => {
		setPosterLoaded(true);
	};

	return (
		<div
			className="px-project px-project-card rounded-xs shadow-card bg-midnight-100 pb-4"
			data-testid="project-card"
		>
			{/* Poster: 4:6 aspect ratio via padding-top trick */}
			<div
				className="relative mb-4 w-full overflow-hidden rounded-t-xs"
				style={{ paddingTop: '150%', backgroundColor: 'hsl(var(--secondary))' }}
			>
				{/* Loaded poster image as background */}
				{safePosterUrl && posterLoaded && (
					<div
						className="absolute inset-0 bg-center bg-cover"
						style={{ backgroundImage: `url(${safePosterUrl})` }}
					/>
				)}

				{/* Loading state: movie icon mask */}
				{!posterLoaded && (
					<div className="absolute inset-0 px-project-poster-loading" />
				)}

				{/* Badges */}
				<div className="absolute inset-x-0 top-0 flex flex-wrap gap-2 p-3">
					{project.flags.includes('new') && <LegacyBadge label="New" />}
					{project.flags.includes('updated') && <LegacyBadge label="Updated" />}
				</div>

				{/* Edit button */}
				{canEdit && (
					<button
						type="button"
						className="button absolute right-0 bottom-0 m-3 p-0 bg-midnight-300"
						onClick={handleEditClick}
						data-tooltip="Edit Project"
					>
						<Icon use="edit" color="white" />
					</button>
				)}

				{/* Hidden img to trigger load */}
				{safePosterUrl && (
					<img
						src={safePosterUrl}
						onLoad={handleImgLoad}
						alt=""
						className="hide"
					/>
				)}
			</div>

			{/* Project name */}
			<span className="px-4 overflow-hidden text-white font-bold text-sm px-project-name-clamp">
				{project.name}
			</span>
		</div>
	);
}

ProjectCard.propTypes = {
	project: PropTypes.object.isRequired,
	canEdit: PropTypes.bool,
	onEditClick: PropTypes.func
};

export default ProjectCard;
